<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{$t('browse')}}
    </h1>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <span class="text_color">{{$t("allCategories")}}</span>
          </h2>
        </div>
        <div>
          <div class="mobiSection__content">
            <div class="row">
              <router-link :to="{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}" class="col-12 col-md-4 col"  v-for="cat in $props.browse.category" :key="cat.key">
                <div class="thumbCol">
                  <div class="thumbCol__cover">
                      <img :src="cat.coverImg" alt="">
                  </div>
                  <div class="thumbCol__wrap">
                    <span :class="cat.icon"></span>
                    <div>
                      <h2 class="thumbCol__label">{{ cat[`title_${lang_a4all}`].toUpperCase() }}</h2>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>      
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  props: ["browse"],
  computed: mapGetters(["lang_a4all", "country_a4all"]),
  mounted() {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.thumbCol {
  position: relative;
  border-radius: 25px;
  overflow: hidden;
  color: #000;
  display: block;
  height: 320px;

  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: "";
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(35, 0, 77, 0.74);
    transition: 375ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  &:hover .thumbCol__cover img {
    transform: scale(1.05);
  }
}
.thumbCol__cover {
  height: 100%;
  width: 100%;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  right: 0;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.3s ease-in-out;
    transform: translateZ(0);
  }
}
.thumbCol__wrap {
  position: relative;
  text-align: center;
  z-index: 3;
  img {
    width: 120px;
  }
  span:before {
    margin: 0;
    font-size: 3.6rem;
    color: #fff;
  }
}
.thumbCol__label {
  display: block;
  color: #fff;
  margin-top: 15px;
  font-size: 1.4rem;
}
.thumbCol__imgWrap {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    z-index: 1;
    transition: all 0.3s ease-in-out;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}
.thumbCol:hover .thumbCol__imgWrap img {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.thumbCol:hover::before {
  opacity: 0.65;
}
a.col {
  text-decoration: none;
}
@media only screen and (max-width: 991px) {
  .thumbCol {
    height: 220px;
  }
}
@media only screen and (max-width: 589px) {
  .thumbCol {
    height: 160px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/apps4all/Browse.vue